import React from 'react';
import { Admin, Resource } from 'react-admin';
import { UserList } from './resources/Users';
import { NewsletterSubscriberList, NewsletterSubscriberEdit } from "./resources/NewsletterSubscribers";
import { NewsletterCampaignList, NewsletterCampaignCreate, NewsletterCampaignEdit } from "./resources/NewsletterCampaigns";
import { NewsletterSendLogList } from "./resources/NewsletterSendLogs";
import { ServiceMailList, ServiceMailCreate, ServiceMailEdit } from "./resources/ServiceMails";
import { ServiceMailLogList } from "./resources/ServiceMailLogs";
import dataProvider from './dataProvider';
import authProvider from './authProvider';
import CustomLoginPage from './LoginPage';

const AdminApp = () => (
  <Admin
    basename="/frontend-admin-1107"
    dataProvider={dataProvider}
    authProvider={authProvider}
    loginPage={CustomLoginPage}
  >
    <Resource name="users" list={UserList} />
    <Resource name="newsletter/subscribers" list={NewsletterSubscriberList} edit={NewsletterSubscriberEdit} />
    <Resource name="newsletter/campaigns" list={NewsletterCampaignList} create={NewsletterCampaignCreate} edit={NewsletterCampaignEdit} />
    <Resource name="newsletter/sendlogs" list={NewsletterSendLogList} />
    <Resource name="service-mails" list={ServiceMailList} create={ServiceMailCreate} edit={ServiceMailEdit} options={{ label: "Mails / Service" }} />
    <Resource name="service-mail-logs" list={ServiceMailLogList} options={{ label: "Mails / Service Logs" }} />
  </Admin>
);

export default AdminApp;
